import _toConsumableArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { AuthenticationError } from "apollo-server-errors";
import UserToken from "@/lib/userToken";
import { AUTH_ERROR_MESSAGES } from "@/lib/errors";
import { metaSchemas, userRating } from "@/lib/constants";
import { isEnded } from "@/lib/metaUtil";
import dayjs from "@/lib/day";
import config from "@/lib/config";
export function createToken(_x, _x2, _x3, _x4, _x5) {
  return _createToken.apply(this, arguments);
}

function _createToken() {
  _createToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(req, res, user, signature, rememberme) {
    var _user$user, _user$user$values, _user$user2, _user$user2$values;

    var userToken, payload, token;
    return _regeneratorRuntime.wrap(function _callee3$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            userToken = new UserToken(req, res);
            payload = {
              id: user.token_id,
              hashedUserId: user === null || user === void 0 ? void 0 : (_user$user = user.user) === null || _user$user === void 0 ? void 0 : (_user$user$values = _user$user.values) === null || _user$user$values === void 0 ? void 0 : _user$user$values.user_id_hash,
              mySkpRelation: !!(user !== null && user !== void 0 && (_user$user2 = user.user) !== null && _user$user2 !== void 0 && (_user$user2$values = _user$user2.values) !== null && _user$user2$values !== void 0 && _user$user2$values.my_sptv_email),
              accessToken: user.access_token,
              refreshToken: user.refresh_token,
              tokenExpiredAt: dayjs().add(user.expires_in, "second").format(),
              rememberme: rememberme
            };
            _context4.next = 4;
            return userToken.sign(payload, signature);

          case 4:
            token = _context4.sent;
            req.userToken = payload;
            return _context4.abrupt("return", token);

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee3);
  }));
  return _createToken.apply(this, arguments);
}

export function sleep(n) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, n);
  });
}
export function createPageInfo(_ref) {
  var offset = _ref.offset,
      limit = _ref.limit,
      count = _ref.count;
  return {
    offset: offset,
    limit: limit,
    totalCount: count,
    hasNextPage: offset + limit < count,
    hasPreviousPage: offset > 0
  };
}
export function thumbnailUrl(obj, _args, _ref2) {
  var _obj$thumbnail;

  var req = _ref2.req;

  if (!isAllowedRating(req, obj)) {
    return "/images/mask.png";
  }

  var noimage = req.adultMode ? "/images/noimage_ex.png" : "/images/noimage.png";
  return (obj === null || obj === void 0 ? void 0 : (_obj$thumbnail = obj.thumbnail) === null || _obj$thumbnail === void 0 ? void 0 : _obj$thumbnail.org) || noimage;
}
export function smallThumbnailUrl(obj, _args, _ref3) {
  var _obj$thumbnail2;

  var req = _ref3.req;

  if (!isAllowedRating(req, obj)) {
    return "/images/mask.png";
  }

  var noimage = req.adultMode ? "/images/noimage_ex.png" : "/images/noimage.png";
  return (obj === null || obj === void 0 ? void 0 : (_obj$thumbnail2 = obj.thumbnail) === null || _obj$thumbnail2 === void 0 ? void 0 : _obj$thumbnail2.small) || noimage;
}
export function mediumThumbnailUrl(obj, _args, _ref4) {
  var _obj$thumbnail3;

  var req = _ref4.req;

  if (!isAllowedRating(req, obj)) {
    return "/images/mask.png";
  }

  var noimage = req.adultMode ? "/images/noimage_ex.png" : "/images/noimage.png";
  return (obj === null || obj === void 0 ? void 0 : (_obj$thumbnail3 = obj.thumbnail) === null || _obj$thumbnail3 === void 0 ? void 0 : _obj$thumbnail3.medium) || noimage;
}
export function largeThumbnailUrl(obj, _args, _ref5) {
  var _obj$thumbnail4;

  var req = _ref5.req;

  if (!isAllowedRating(req, obj)) {
    return "/images/mask.png";
  }

  var noimage = req.adultMode ? "/images/noimage_ex.png" : "/images/noimage.png";
  return (obj === null || obj === void 0 ? void 0 : (_obj$thumbnail4 = obj.thumbnail) === null || _obj$thumbnail4 === void 0 ? void 0 : _obj$thumbnail4.large) || noimage;
}
export function isAuthenticated() {
  return function (next) {
    return /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(root, args, context, info) {
        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (context.req.userToken) {
                  _context2.next = 2;
                  break;
                }

                throw new AuthenticationError(AUTH_ERROR_MESSAGES["notauthenticated"]);

              case 2:
                return _context2.abrupt("return", next(root, args, context, info));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee);
      }));

      return function (_x6, _x7, _x8, _x9) {
        return _ref6.apply(this, arguments);
      };
    }();
  };
}
export function values(obj, name) {
  var _obj$values;

  return obj === null || obj === void 0 ? void 0 : (_obj$values = obj.values) === null || _obj$values === void 0 ? void 0 : _obj$values[name];
}
export function ownerOnly() {
  return function (next) {
    return /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(root, args, context, info) {
        var _context$req;

        var userToken;
        return _regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                userToken = (_context$req = context.req) === null || _context$req === void 0 ? void 0 : _context$req.userToken;

                if (userToken) {
                  _context3.next = 3;
                  break;
                }

                throw new AuthenticationError(AUTH_ERROR_MESSAGES["notauthenticated"]);

              case 3:
                if (!(userToken.id !== userToken.currentProfile)) {
                  _context3.next = 5;
                  break;
                }

                throw new AuthenticationError(AUTH_ERROR_MESSAGES["notauthenticated"]);

              case 5:
                return _context3.abrupt("return", next(root, args, context, info));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x10, _x11, _x12, _x13) {
        return _ref7.apply(this, arguments);
      };
    }();
  };
}
export function metaResolveType(meta, _context, _info) {
  var _meta$values, _meta$values4;

  if (meta.schema_key) {
    switch (meta.schema_key) {
      case metaSchemas.tvshow.key:
        return "TVShowMeta";

      case metaSchemas.season.key:
        return "SeasonMeta";

      case metaSchemas.episode.key:
        if (meta !== null && meta !== void 0 && (_meta$values = meta.values) !== null && _meta$values !== void 0 && _meta$values.is_live) {
          var _meta$values2, _meta$values3;

          var ended = isEnded(meta === null || meta === void 0 ? void 0 : (_meta$values2 = meta.values) === null || _meta$values2 === void 0 ? void 0 : _meta$values2.encode_end_date); // ライブが終わって見逃し対応ならEpisodeMetaとして扱う

          if (meta !== null && meta !== void 0 && (_meta$values3 = meta.values) !== null && _meta$values3 !== void 0 && _meta$values3.catch_up_flag && ended) {
            return "EpisodeMeta";
          } else {
            return "LiveMeta";
          }
        } else {
          return "EpisodeMeta";
        }

      case metaSchemas.channel.key:
        return "ChannelMeta";

      case metaSchemas.linear.key:
        return "LinearMeta";
    }
  } else if (meta.schema_id) {
    switch (meta.schema_id) {
      case metaSchemas.tvshow.id:
        return "TVShowMeta";

      case metaSchemas.season.id:
        return "SeasonMeta";

      case metaSchemas.episode.id:
        if (meta !== null && meta !== void 0 && (_meta$values4 = meta.values) !== null && _meta$values4 !== void 0 && _meta$values4.is_live) {
          var _meta$values5, _meta$values6;

          var _ended = isEnded(meta === null || meta === void 0 ? void 0 : (_meta$values5 = meta.values) === null || _meta$values5 === void 0 ? void 0 : _meta$values5.encode_end_date); // ライブが終わって見逃し対応ならEpisodeMetaとして扱う


          if (meta !== null && meta !== void 0 && (_meta$values6 = meta.values) !== null && _meta$values6 !== void 0 && _meta$values6.catch_up_flag && _ended) {
            return "EpisodeMeta";
          } else {
            return "LiveMeta";
          }
        } else {
          return "EpisodeMeta";
        }

      case metaSchemas.channel.id:
        return "ChannelMeta";

      case metaSchemas.linear.id:
        return "LinearMeta";
    }
  }

  return null;
}
export function taxCalculation(price) {
  if (typeof price !== "number") return null;
  return Math.floor(price + price * config.taxRate);
}
export function genres(obj) {
  var genres = values(obj, "genres"); // 複数ジャンルが入稿されたメタの場合
  // 親ジャンル1, 子ジャンル1, 親ジャンル2, 子ジャンル2
  // と入っているので先頭2件までにする

  if (genres.length > 2) {
    return genres.slice(0, 2);
  } else {
    return genres;
  }
}
export function isDateRangeIn(start, end) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    buffer: null,
    default: true
  };

  var now = function () {
    if (options.buffer) {
      var _dayjs;

      // {buffer: [1, "minute"]}
      return (_dayjs = dayjs()).add.apply(_dayjs, _toConsumableArray(options.buffer));
    } else {
      return dayjs();
    }
  }();

  var startAt = dayjs(new Date(start));
  var endAt = dayjs(new Date(end));

  if (start && end) {
    return now.isBetween(startAt, endAt, null, "[)");
  } else if (start && !end) {
    return now.isSameOrAfter(startAt);
  } else if (!start && end) {
    return now.isBefore(end);
  } else {
    return options === null || options === void 0 ? void 0 : options.default;
  }
}
export function logicaErrorCode(e) {
  var _e$extensions;

  if (e !== null && e !== void 0 && (_e$extensions = e.extensions) !== null && _e$extensions !== void 0 && _e$extensions.response) {
    var _e$extensions$respons, _body$error;

    console.dir(e.extensions.response);
    var body = (_e$extensions$respons = e.extensions.response) === null || _e$extensions$respons === void 0 ? void 0 : _e$extensions$respons.body;
    return (_body$error = body.error) === null || _body$error === void 0 ? void 0 : _body$error.code;
  } else {
    return 500;
  }
}
export function logicaErrorBody(e) {
  var _e$extensions2;

  if (e !== null && e !== void 0 && (_e$extensions2 = e.extensions) !== null && _e$extensions2 !== void 0 && _e$extensions2.response) {
    var _e$extensions$respons2;

    console.dir(e.extensions.response);
    var body = (_e$extensions$respons2 = e.extensions.response) === null || _e$extensions$respons2 === void 0 ? void 0 : _e$extensions$respons2.body;
    return body;
  } else {
    return {};
  }
}
export function isAllowedRating(req, meta) {
  var _req$userToken;

  if (req.userToken && typeof ((_req$userToken = req.userToken) === null || _req$userToken === void 0 ? void 0 : _req$userToken.rating) !== "undefined") {
    var rating = req.userToken.rating;
    var permitRating = userRating[rating].permitRating;
    return permitRating.includes(meta.values.rating);
  }

  return true;
}
export function ratingMask(req, meta, attr) {
  if (!isAllowedRating(req, meta)) {
    return meta[attr].replace(/./g, "*");
  }

  return meta === null || meta === void 0 ? void 0 : meta[attr];
}
export function dateFormat(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "YYYY/MM/DD";
  if (!date) return null;
  return dayjs(date).format(format);
}